import { User } from './user';
import { Division } from './division';

export class BluePrintTicket {
  ticket_id: string;
  subject: string;
  status: string;
  division: string;
  label: number;
  type: string;
  cust_id: string;
  last_replied_by: string;
  thread: Array<Thread>;
  taken_by: string;
  log: Array<string>;
}

export class Thread {
  created_at: string; // filled in server side
  created_by: string;
  message: string;
  attachments: Array<Attachment>;
}

export class Attachment {
  extension: string;
  filename: string;
  hashedfilename: string;
  filesize: number;
}

export class TicketCount {
  open: number;
  taken: number;
  solved: number;
  closed: number;
}

export class Ticket extends BluePrintTicket {
  _id: string;
  created_at: string;
  thread_replier_detail: Array<ThreadReplierDetail>;
  officer_detail: User;
  division_detail: Division;
  updated_at: string;
  cust_detail: User;
  last_replied_at: string;
}

export class TicketList {
  has_remaining_data: boolean;
  tickets: Array<Ticket>;
}

export class ThreadReplierDetail {
  fullname: string;
  company_name: string;
  profile_picture: string;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/ticket.ts